import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "./components/atoms/ErrorBoundary";
import { BASE_PATH } from "./lib/config";
import DashboardPage from "./pages/DashboardPage";
import { StatusPage } from "./pages/StatusPage";
import { IncidentDetailPage } from "./pages/IncidentDetailPage";
import { SubscribeConfirmPage } from "./pages/SubscribeConfirmPage";
import { UnsubscribedPage } from "./pages/UnsubscribedPage";
import { ProtectedRoute } from "./components/atoms/ProtectedRoute";
import { AdminLayout } from "./components/templates/AdminLayout";
import { LoginPage } from "./pages/admin/LoginPage";
import { StatusManagementPage } from "./pages/admin/StatusManagementPage";
import { IncidentManagementPage } from "./pages/admin/IncidentManagementPage";
import { MaintenancePage } from "./pages/admin/MaintenancePage";
import { ServiceRegistryPage } from "./pages/admin/ServiceRegistryPage";
import { MonitorDashboardPage } from "./pages/admin/MonitorDashboardPage";
import { WebhookConfigPage } from "./pages/admin/WebhookConfigPage";
import { OnCallPage } from "./pages/admin/OnCallPage";
import { LogsPage } from "./pages/admin/LogsPage";
import { MetricsPage } from "./pages/admin/MetricsPage";
import { TracesPage } from "./pages/admin/TracesPage";
import { ErrorsPage } from "./pages/admin/ErrorsPage";
import { SLOPage } from "./pages/admin/SLOPage";
import { DashboardsPage } from "./pages/admin/DashboardsPage";
import { DashboardEditorPage } from "./pages/admin/DashboardEditorPage";
import { WorkflowsPage } from "./pages/admin/WorkflowsPage";
import { WorkflowExecutionsPage } from "./pages/admin/WorkflowExecutionsPage";
import { PublicDashboardPage } from "./pages/PublicDashboardPage";
import { SubscribePage } from "./pages/SubscribePage";
import { TemplatesPage } from "./pages/admin/TemplatesPage";
import { SubscribersPage } from "./pages/admin/SubscribersPage";
import { ThirdPartyServicesPage } from "./pages/admin/ThirdPartyServicesPage";
import { UserAccessPage } from "./pages/admin/UserAccessPage";
import { SubscriptionSettingsPage } from "./pages/admin/SubscriptionSettingsPage";
import "./styles/subscribe.css";

export default function App() {
  return (
    <BrowserRouter basename={BASE_PATH || undefined}>
      <ErrorBoundary>
      <Routes>
        <Route path="/" element={<StatusPage />} />
        <Route path="/status" element={<StatusPage />} />
        <Route path="/status/incidents/:id" element={<IncidentDetailPage />} />
        <Route path="/subscribe" element={<SubscribePage />} />
        <Route path="/status/subscribe" element={<SubscribePage />} />
        <Route path="/status/subscribe/confirm" element={<SubscribeConfirmPage />} />
        <Route path="/status/subscribe/unsubscribed" element={<UnsubscribedPage />} />
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/dashboard/:token" element={<PublicDashboardPage />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="status" replace />} />
          <Route path="status" element={<StatusManagementPage />} />
          <Route path="incidents" element={<IncidentManagementPage />} />
          <Route path="maintenance" element={<MaintenancePage />} />
          <Route path="registry" element={<ServiceRegistryPage />} />
          <Route path="monitor" element={<MonitorDashboardPage />} />
          <Route path="webhooks" element={<WebhookConfigPage />} />
          <Route path="oncall" element={<OnCallPage />} />
          <Route path="logs" element={<LogsPage />} />
          <Route path="metrics" element={<MetricsPage />} />
          <Route path="traces" element={<TracesPage />} />
          <Route path="errors" element={<ErrorsPage />} />
          <Route path="slo" element={<SLOPage />} />
          <Route path="dashboards" element={<DashboardsPage />} />
          <Route path="dashboards/:id" element={<DashboardEditorPage />} />
          <Route path="workflows" element={<WorkflowsPage />} />
          <Route path="workflows/executions" element={<WorkflowExecutionsPage />} />
          <Route path="templates" element={<TemplatesPage />} />
          <Route path="subscribers" element={<SubscribersPage />} />
          <Route path="third-party" element={<ThirdPartyServicesPage />} />
          <Route path="users" element={<UserAccessPage />} />
          <Route path="subscription-settings" element={<SubscriptionSettingsPage />} />
        </Route>
      </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
